import ReportDefaultsConfiguration from './ReportDefaultsConfiguration'
export default ReportDefaultsConfiguration
